module.exports = __webpack_public_path__ + "1129226c322e97733394300a07bbc5db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Yellow2.jpg
// module id = 14
// module chunks = 0